import { UNKNOWN_MODEL } from "./constants";
import { useImageLoader } from "./hooks";
import { ModelImageProps } from "./types";

const ModelImage = ({ model }: ModelImageProps) => {
    const { getModelImagePath } = useImageLoader();

    const src = getModelImagePath(model);
    const src2x = getModelImagePath(model, "@2x");
    const srcSet = src2x ? `${src2x} 2x` : undefined;

    return (
        <img
            src={src}
            srcSet={srcSet}
            alt={model || UNKNOWN_MODEL}
            loading="lazy"
        />
    );
};

export default ModelImage;
